import { IFileCustom, useInputFile } from "./useInputFile";
import { FileUploader } from "react-drag-drop-files";
import { useEffect } from "react";
import * as S from "./styles";
import { DropPlusIcon } from "./dropPlusIcon";

type InputFileProps = {
  onChange: (file: IFileCustom) => void;
  fileTypes: string[];
  label?: string;
  icon?: React.ReactNode;
};

export const InputFile = ({
  onChange,
  fileTypes,
  label,
  icon,
}: InputFileProps) => {
  const { dropHandler, file } = useInputFile();

  useEffect(() => {
    onChange && onChange(file as IFileCustom);
  }, [file]);

  return (
    <>
      <S.Container>
        <S.WrapperInputFile>
          <FileUploader
            dropMessageStyle={{
              backgroundColor: "#ECF0F8",
              borderRadius: 12,
              border: "none",
            }}
            handleChange={dropHandler}
            name="file"
            hoverTitle=" "
            types={fileTypes}
          >
            <S.DragDrop>
              {icon ?? (
                <DropPlusIcon
                  width={"auto"}
                  height={"auto"}
                  style={{ width: 50, minWidth: 50 }}
                />
              )}
              {label ? (
                <p>{label}</p>
              ) : (
                <p>
                  Clique para <span>adicionar</span> ou <span>arraste</span> e{" "}
                  <span>solte</span> um arquivo de imagem ou áudio aqui.
                </p>
              )}
            </S.DragDrop>{" "}
          </FileUploader>
        </S.WrapperInputFile>
      </S.Container>
    </>
  );
};
